import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { TabViewModule } from 'primeng/tabview';

@Component({
  selector: 'kon-dynamic-form-tabs',
  standalone: true,
  imports: [CommonModule, TabViewModule, FormlyModule],
  template: `
    <p-tabView [(activeIndex)]="activeIndex" [ngClass]="field.className">
      <p-tabPanel
        *ngFor="let tab of field.fieldGroup; let i = index; let last = last"
        [header]="tab.props?.label ?? ''"
        [ngClass]="field.fieldGroupClassName"
      >
        <formly-field [field]="tab"></formly-field>
      </p-tabPanel>
    </p-tabView>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyTabsTypeComponent extends FieldType {
  activeIndex = 0;

  isValid(field: FormlyFieldConfig): boolean {
    if (field.key) {
      return field.formControl?.valid === true;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isValid(f))
      : true;
  }
}
